module.exports = "/_next/static/images/CollectDataDetails@2x-a344ff4002a24ede63d119921408ac04.png";